import { useEffect, useState } from "react";
import { FieldError, UseFormRegister, UseFormSetValue } from "react-hook-form";

interface MyMultiSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  error?: FieldError;
  validationRules?: object;
  type?: "string" | "number"; // Explicitly type 'type'
  selected?: any;
  options: { value: string; label: string }[];
}

export function MyMultiSelect({
  name,
  register,
  setValue,
  error,
  type = "string", // Default to "string" if not provided
  validationRules,
  selected,
  options,
  ...rest
}: MyMultiSelectProps) {
  const [selectValues, setSelectValues] = useState<string[]>([]);

  useEffect(() => {
    if (selected) {
      const newValues = Array.isArray(selected)
        ? selected.map((item) => String(item))
        : [String(selected)];
      setSelectValues(newValues);
      const formattedValues =
        type === "number" ? newValues.map(Number) : newValues;
      setValue(name, formattedValues);
    } else {
      setSelectValues([]);
      setValue(name, []);
    }
  }, [selected, name, setValue, type]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOptions = Array.from(
      event.target.selectedOptions,
      (option) => option.value,
    );
    setSelectValues(selectedOptions);
    const formattedValues =
      type === "number" ? selectedOptions.map(Number) : selectedOptions;
    setValue(name, formattedValues);
  };

  return (
    <div>
      <select
        {...register(name, validationRules)}
        {...rest}
        multiple
        value={selectValues}
        onChange={handleChange}
        className="h-auto w-full border px-4 py-1 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
    </div>
  );
}
